import React from 'react';
import {
    useProperty,
    usePropertyFetching,
} from '../../../contextsProperty/ContextProperties';
import TextInput from '../../../../muiComponents/TextInput/TextInputV2';
import SwitchInput from '../../../../muiComponents/switchInput/SwitchInput';
import Card from '../../components/Card';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import {
    doubleColumnGrid,
    gridColumnsSpacing,
    gridRowsSpacing,
} from '../../../../utils/property/propertyUtils';
import '../../../../stylesheets/stylesLayout/yourProperties.scss';
import LoadingTab from '../LoadingTab';
import Title from '../Title';

export default function KidPolicies() {
    const {
        primary,
        adultsOnly,
        adultAge,
        babiesAge,
        firstChildAge,
        secondChildAge,
        handleInputChange,
    } = useProperty();
    const { isFetching } = usePropertyFetching();

    if (isFetching) {
        return <LoadingTab />;
    }

    return (
        <div className='your-property__container'>
            <Title
                as='h1'
                text={'kids_policies_title'}
                className='text-align-center'
            />
            <Card className='your-properties__form'>
                <SwitchInput
                    checked={!adultsOnly}
                    onChangeMethod={e => {
                        handleInputChange('adultsOnly', !e.target.checked);
                    }}
                    labelText={'accept_kids'}
                    disabled={!primary}
                    style={{ marginBottom: '20px' }}
                />
                <TextInput
                    labelText={'age_adult_mob'}
                    handleChange={e =>
                        handleInputChange('adultAge', parseInt(e.target.value))
                    }
                    value={adultAge}
                    name='adultAge'
                    type='number'
                    disabled={!primary}
                    variant={!primary ? 'filled' : 'outlined'}
                    style={{ marginBottom: '40px' }}
                />
                {!adultsOnly && (
                    <Grid
                        columnSpacing={gridColumnsSpacing}
                        rowSpacing={gridRowsSpacing}
                        style={{ width: 'unset' }}
                    >
                        <GridChild gridProps={doubleColumnGrid}>
                            <TextInput
                                labelText={'age_infant_mob'}
                                handleChange={e =>
                                    handleInputChange(
                                        'babiesAge',
                                        parseInt(e.target.value)
                                    )
                                }
                                value={babiesAge}
                                name='babiesAge'
                                type='number'
                                disabled={!primary}
                                variant={!primary ? 'filled' : 'outlined'}
                            />
                        </GridChild>
                        <GridChild gridProps={doubleColumnGrid}>
                            <TextInput
                                labelText={'age_child_mob'}
                                handleChange={e =>
                                    handleInputChange(
                                        'firstChildAge',
                                        parseInt(e.target.value)
                                    )
                                }
                                value={firstChildAge}
                                name='firstChildAge'
                                type='number'
                                disabled={!primary}
                                variant={!primary ? 'filled' : 'outlined'}
                            />
                        </GridChild>
                        <GridChild gridProps={doubleColumnGrid}>
                            <TextInput
                                labelText={'age_teenager_mob'}
                                handleChange={e =>
                                    handleInputChange(
                                        'secondChildAge',
                                        parseInt(e.target.value)
                                    )
                                }
                                value={secondChildAge}
                                name='secondChildAge'
                                type='number'
                                disabled={!primary}
                                variant={!primary ? 'filled' : 'outlined'}
                            />
                        </GridChild>
                    </Grid>
                )}
            </Card>
        </div>
    );
}
